/* eslint-disable max-len */
var WEATHER_UMBRELLA = {
  "default": 'M32,18V17A17.29,17.29,0,0,0,27.31,4.68,15.64,15.64,0,0,0,16,0,15.56,15.56,0,0,0,4.67,4.71,17.41,17.41,0,0,0,0,17v1H13.94v8.07a6.21,6.21,0,0,0,6,5.93,5.93,5.93,0,0,0,4.25-1.89,6,6,0,0,0,1.75-4h-2a4,4,0,0,1-1.19,2.65A4,4,0,0,1,19.94,30a4.22,4.22,0,0,1-4-3.93V18ZM6.1,6.1A13.61,13.61,0,0,1,16,2a13.65,13.65,0,0,1,9.9,4.07A15.12,15.12,0,0,1,30,16H2A15.18,15.18,0,0,1,6.1,6.1Z'
};

export { WEATHER_UMBRELLA };
//# sourceMappingURL=WEATHER_UMBRELLA.js.map
